/**
 * @Author: Zewei
 * @Date:   2018-01-19T13:34:04+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T13:21:23+08:00
 */
 import React from 'react';
 import PropTypes from 'prop-types';
 import { Layout } from 'antd';
 import DocumentTitle from 'react-document-title';
 import { connect } from 'react-redux';
 // import { Route, Redirect, Switch } from 'react-router-dom';
 import { ContainerQuery } from 'react-container-query';
 import { enquireScreen } from 'enquire-js';
 import classNames from 'classnames';
 import GlobalHeader from '../components/GlobalHeader';
 import GlobalFooter from '../components/GlobalFooter';
 import SiderMenu from '../components/SiderMenu';
 // import NotFound from '../routes/Exception/404';
 // import { getRoutes } from '../utils/utils';
 // import Authorized from '../utils/Authorized';
 // import { getMenuData } from '../common/menu';
 import { fetchDynamicMenu, fetchUserDynamicMenu, fetchCurrentUser, logout ,change_password, change_second_password } from '../actions/user-actions.js';
 // import logo from '../logo.svg';
 import logo from '../logo.png';
 // import _util from '../utils/index.js';
// import { Redirect } from 'react-router-dom';



 const { Content } = Layout;
 // const { AuthorizedRoute } = Authorized;

 const thisYear = (new Date()).getFullYear();

 // 处理 后台返回的 动态menu json列表
 function formatter(data, parentPath = '') {
   const list = [];
   data.forEach((item) => {
     if (item.children) {
       list.push({
         ...item,
         path: `${parentPath}${item.path}`,
         children: formatter(item.children, `${parentPath}${item.path}/`),
       });
     } else {
       list.push({
         ...item,
         path: `${parentPath}${item.path}`,
       });
     }
   });
   return list;
 }

 /**
  * 根据菜单取得重定向地址.
  */
 const redirectData = [];
 const getRedirect = (item) => {
   if (item && item.children) {
     if (item.children[0] && item.children[0].path) {
       redirectData.push({
         from: `/${item.path}`,
         to: `/${item.children[0].path}`,
       });
       item.children.forEach((children) => {
         getRedirect(children);
       });
     }
   }
 };
 // getMenuData().forEach(getRedirect);

 const query = {
   'screen-xs': {
     maxWidth: 575,
   },
   'screen-sm': {
     minWidth: 576,
     maxWidth: 767,
   },
   'screen-md': {
     minWidth: 768,
     maxWidth: 991,
   },
   'screen-lg': {
     minWidth: 992,
     maxWidth: 1199,
   },
   'screen-xl': {
     minWidth: 1200,
   },
 };

 let isMobile;
 enquireScreen((b) => {
   isMobile = b;
 });

const mapStateToProps = state => {
    return {
        user: state.user,
        routing: state.routing
    }
}

const mapDispatchToProps = { fetchDynamicMenu, fetchUserDynamicMenu, fetchCurrentUser, logout, change_password, change_second_password };

export default (WrappedComponent) => {
        class WrappedBasicLayout extends React.Component {

          static childContextTypes = {
            location: PropTypes.object,
            breadcrumbNameMap: PropTypes.object,
          }

          state = {
            isMobile,
            tabIndex: sessionStorage.getItem("tabIndex")
          };

          changeTabIndex = index => {
            sessionStorage.setItem("tabIndex", index)
            this.setState({tabIndex: sessionStorage.getItem("tabIndex")})
          }

          getChildContext() {
            const { location, routerData } = this.props;
            return {
              location,
              breadcrumbNameMap: routerData,
            };
          }

          componentDidMount() {
            // console.log(this.props)
            // console.log(this.props.routing.location.pathname.split('/')[2]);
            this.setState({routerMenu:this.props.routing.location.pathname})
            // console.log((new WrappedComponent).childModuleName)
            // enquireScreen((mobile) => {
            //   this.setState({
            //     isMobile: mobile,
            //   });
            // });
            // this.props.fetchDynamicMenu()
            // this.props.fetchCurrentUser()
            // this.props.dispatch({
            //   type: 'user/fetchCurrent',
            // });
          }

          componentWillMount () {
                        // console.log('xxx')
            enquireScreen((mobile) => {
              this.setState({
                isMobile: mobile,
              });
            });
            // this.setState({tabIndex: 1})
            if (!this.props.user.currentUser) {
              this.props.fetchDynamicMenu()
              this.props.fetchUserDynamicMenu()
              this.props.fetchCurrentUser()
              if (!sessionStorage.getItem("tabIndex")) {
                sessionStorage.setItem("tabIndex", "1")
              }
              this.setState({tabIndex: sessionStorage.getItem("tabIndex")})
            }
          }

          componentWillReceiveProps(nextProps) {
            // console.log(nextProps);
          }
          // getPageTitle() {
          //   const { routerData, location } = this.props;
          //   const { pathname } = location;
          //   let title = 'Ant Design Pro';
          //   if (routerData[pathname] && routerData[pathname].name) {
          //     title = `${routerData[pathname].name} - Ant Design Pro`;
          //   }
          //   return title;
          // }

          handleMenuCollapse = (collapsed) => {
            // this.props.dispatch({
            //   type: 'global/changeLayoutCollapsed',
            //   payload: collapsed,
            // });
          }
          handleNoticeClear = (type) => {
            // message.success(`清空了${type}`);
            // this.props.dispatch({
            //   type: 'global/clearNotices',
            //   payload: type,
            // });
          }

          handleMenuClick = ({ key }) => {
            if (key === 'logout') {
              this.props.logout()
            } else if (key==='change_password') {
                  this.props.change_password()
            } else if (key==='change_second_password') {
              this.props.change_second_password()
            }
          }

          handleNoticeVisibleChange = (visible) => {
            // if (visible) {
            //   this.props.dispatch({
            //     type: 'global/fetchNotices',
            //   });
            // }
          }

          render() {
            // const {
            //   currentUser, collapsed, fetchingNotices, notices, routerData, match, location,
            // } = this.props;

            const { user, location } = this.props;
            let currentUser = user.currentUser,
                menus = [],
                userMenus=[],
                layout,
                is_english=false;

            if (user && user.authInfo) {
                menus = formatter(user.authInfo.Menus);
                is_english=user.authInfo.is_english
            }
            if (user && user.employeeUserInfo) {
                userMenus = formatter(user.employeeUserInfo.Menus);
            }
            // const routerRedirect = router => this.props.history.push(router)
            // console.log("------", user, userMenus)
            // console.log(this.props.user.currentUser)
            if (user.authInfo) {
                const permissions = require("./permissions.json");
                const realPermission = {
                  ...permissions,
                  ...this.props.user.currentUser.PermissionDict
                }
                layout = (
                    <Layout>
                        <SiderMenu

                            logo={logo}
                            // 不带Authorized参数的情况下如果没有权限,会强制跳到403界面
                            // If you do not have the Authorized parameter
                            // you will be forced to jump to the 403 interface without permission
                            // Authorized={Authorized}
                            //静态 获取 menu 列表
                            // menuData={getMenuData()}
                            // 动态 获取 menu 列表
                            menuData={menus}
                            is_english={is_english}
                            //员工PC端动态菜单
                            menuUserData={userMenus}
                            routerMenu={this.state.routerMenu}
                            collapsed={false}
                            location={location} // eslint-disable-line
                            isMobile={this.state.isMobile}
                            onCollapse={this.handleMenuCollapse}
                            isManager={menus.length > 0}
                            tabIndex={this.state.tabIndex}
                            changeTabIndex={this.changeTabIndex}
                        />
                        <Layout>
                            <GlobalHeader
                                logo={logo}
                                currentUser={currentUser}
                                // fetchingNotices={fetchingNotices}
                                // notices={notices}
                                collapsed={false}
                                isMobile={this.state.isMobile}
                                // onNoticeClear={this.handleNoticeClear}
                                onCollapse={this.handleMenuCollapse}
                                onMenuClick={this.handleMenuClick}

                                // onNoticeVisibleChange={this.handleNoticeVisibleChange}
                            />
                            <Content style={{ margin: '10px 10px', height: '100%' }}>
                                <div style={{ minHeight: 'calc(100vh - 260px)' }}>
                                    {/*
                                        <Switch>
                                            {
                                            redirectData.map(item =>
                                            <Redirect key={item.from} exact from={item.from} to={item.to} />
                                                )
                                            }
                                            {
                                            getRoutes(match.path, routerData).map(item => (
                                            <Route
                                            key={item.key}
                                            path={item.path}
                                            component={item.component}
                                            exact={item.exact}
                                                    />
                                                ))
                                            }
                                            <Redirect exact from="/" to="/dashboard/analysis" />
                                            <Route render={NotFound} />
                                        </Switch>
                                    */}
                                    <WrappedComponent history={this.props.history}
                                      webCurrentUser={this.props.user}
                                      access={realPermission} />
                                </div>
                                <GlobalFooter
                                    // links={[{
                                    //     title: '首页',
                                    //     href: '/',
                                    //     blankTarget: true,
                                    //     key:"link_index"
                                    // }, {
                                    //     title: '关于',
                                    //     href: '/',
                                    //     blankTarget: true,
                                    //     key: "link_about"
                                    // }, {
                                    //     title: 'lorem',
                                    //     href: '/',
                                    //     blankTarget: true,
                                    //     key: "link_lorem"
                                    // }]}
                                    copyright={
                                        <div>
                                            Copyright &copy; {thisYear} 上海长颈鹿美语培训中心 版权所有.
                                        </div>
                                    }
                                />
                            </Content>
                        </Layout>
                    </Layout>
                  )
                }

            return (
                layout ?
                    <DocumentTitle title="长颈鹿美语">
                        <ContainerQuery query={query}>
                            {params => <div className={classNames(params)}>{ layout }</div>}
                        </ContainerQuery>
                    </DocumentTitle>
                    :
                    ''
            )
          }
        }

        WrappedBasicLayout = connect(mapStateToProps, mapDispatchToProps)(WrappedBasicLayout)

        return WrappedBasicLayout
}


 // export default connect(state => ({
 // }))(BasicLayout);



// WEBPACK FOOTER //
// ./src/layouts/LayoutWrapper.js